<script setup lang="ts">
import { computed } from "vue";
import type { B2BNotice } from "../../models/notice";
import ImageFirestore from "addeus-common-library/components/base/firebase/ImageFirestore.vue";

const maxStars = 5;

interface B2BNoticeProps {
    modelValue: B2BNotice;
}

const props = defineProps<B2BNoticeProps>();

const fullStarNum = computed(() => {
    return Math.floor(props.modelValue.rate);
});
const hasDecimal = computed(() => {
    return Math.trunc(props.modelValue.rate) !== props.modelValue.rate;
});
const emptyStarNum = computed(() => {
    return maxStars - (fullStarNum.value + (hasDecimal.value ? 1 : 0));
});
</script>

<template>
    <div style="min-width: 250px; max-width: 600px; width: 95%; padding: 3px">
        <div class="is-flex is-flex-direction-column p-5 card has-background-light">
            <div
                class="is-flex is-flex-direction-row is-justify-content-space-between is-flex-grow-0 pb-4">
                <div class="my-auto">
                    <span
                        v-for="n in fullStarNum"
                        :key="n as number"
                        class="material-icons-outlined has-text-gold is-size-3 is-size-5-mobile">
                        star
                    </span>
                    <span
                        v-if="hasDecimal"
                        class="material-icons-outlined has-text-gold is-size-3 is-size-5-mobile"
                        >star_half</span
                    >
                    <span
                        v-for="n in emptyStarNum"
                        :key="n as number"
                        class="material-icons-outlined has-text-gold is-size-3 is-size-5-mobile">
                        star_outline
                    </span>
                </div>
                <div v-if="props.modelValue.logo !== undefined" style="max-width: 50%">
                    <ImageFirestore
                        :path="props.modelValue.logo"
                        alt="business-logo"
                        style="max-height: 75px"></ImageFirestore>
                </div>
                <!-- Image -->
            </div>
            <div
                style="white-space: pre-line; font-weight: 500"
                class="mb-auto has-text-silver">
                {{ props.modelValue.comment }}
            </div>
            <div class="mt-5">
                <p class="has-text-black" style="font-weight: 400">
                    <span class="has-text-weight-bold">
                        {{ props.modelValue.personName }},
                    </span>
                    {{ props.modelValue.jobName }},
                </p>
                <p class="has-text-black">
                    {{ props.modelValue.businessName }}
                </p>
            </div>
        </div>
    </div>
</template>